import React from 'react';

import { IsoCountryCode2, Language } from '@rbilabs/intl';
import { CognitoUserSession } from 'amazon-cognito-identity-js';
import { createRoot } from 'react-dom/client';

import { LaunchDarklyFlagsObject } from 'utils/launchdarkly';
import * as location from 'utils/location';

import App from './app';
import bootstrap from './bootstrap';

// Our automation tests when we're running in integration mode mocks all external requests
// A few APIs require a little special logic to mock properly. This lets us patch the requests
// to get our mocks correctly when we're in test mode and not an E2E suite
if (process.env.REACT_APP_RBI_ENV === 'test' && process.env.CYPRESS_IS_E2E !== 'true') {
  require('./patch-fetch-for-mocks');
}

const searchParams = location.getSearchParams();
const enableWhyDidYouRender = searchParams.get('enableWhyDidYouRender');
if (process.env.NODE_ENV !== 'production' && !window.Cypress && enableWhyDidYouRender === 'true') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
  });
}

export const renderApp = ({
  appLanguage,
  appCountry,
  flags: flattenedFlags,
  userHasSignedIn,
  userSession,
}: {
  appLanguage: Language;
  appCountry: IsoCountryCode2;
  flags: LaunchDarklyFlagsObject;
  userHasSignedIn: boolean;
  userSession: CognitoUserSession | null;
}) => {
  const rootTag: HTMLElement = document.getElementById('root') as HTMLElement;
  const root = createRoot(rootTag);

  root.render(
    <App
      appLanguage={appLanguage}
      appCountry={appCountry}
      ldFlags={flattenedFlags}
      userHasSignedIn={userHasSignedIn}
      userSession={userSession}
    />
  );
};

bootstrap(renderApp);
